__turbopack_context__.v({
  "quoteIcon": "testimonialsSection-module-scss-module__Fb_Poa__quoteIcon",
  "section": "testimonialsSection-module-scss-module__Fb_Poa__section",
  "testimonialAuthor": "testimonialsSection-module-scss-module__Fb_Poa__testimonialAuthor",
  "testimonialAvatar": "testimonialsSection-module-scss-module__Fb_Poa__testimonialAvatar",
  "testimonialCard": "testimonialsSection-module-scss-module__Fb_Poa__testimonialCard",
  "testimonialDot": "testimonialsSection-module-scss-module__Fb_Poa__testimonialDot",
  "testimonialDotActive": "testimonialsSection-module-scss-module__Fb_Poa__testimonialDotActive",
  "testimonialDotActiveProgress": "testimonialsSection-module-scss-module__Fb_Poa__testimonialDotActiveProgress",
  "testimonialDotFill": "testimonialsSection-module-scss-module__Fb_Poa__testimonialDotFill",
  "testimonialName": "testimonialsSection-module-scss-module__Fb_Poa__testimonialName",
  "testimonialQuote": "testimonialsSection-module-scss-module__Fb_Poa__testimonialQuote",
  "testimonialRole": "testimonialsSection-module-scss-module__Fb_Poa__testimonialRole",
  "testimonialsCarouselWrapper": "testimonialsSection-module-scss-module__Fb_Poa__testimonialsCarouselWrapper",
  "testimonialsDots": "testimonialsSection-module-scss-module__Fb_Poa__testimonialsDots",
  "testimonialsEmbla": "testimonialsSection-module-scss-module__Fb_Poa__testimonialsEmbla",
  "testimonialsEmblaContainer": "testimonialsSection-module-scss-module__Fb_Poa__testimonialsEmblaContainer",
  "testimonialsEmblaSlide": "testimonialsSection-module-scss-module__Fb_Poa__testimonialsEmblaSlide",
  "testimonialsSection": "testimonialsSection-module-scss-module__Fb_Poa__testimonialsSection",
});
